@if (form) {
  <form class="action-form" [formGroup]="form">
    <span class="title">{{ 'SUPPORT.HEADER' | translate }}</span>
    <div class="support">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <app-text-area [control]="form.controls['message']" [helpText]="'SUPPORT.HELP_TEXT.MAIL'"></app-text-area>
            <button class="btn btn-active" (click)="sendMail()">{{ 'COMMON.SEND' | translate }}</button>
          </div>
        </div>
      </div>
      <div class="row">
        <button class="link-btn" (click)="cancel()">{{ 'CANCEL_BTN' | translate }}</button>
      </div>
    </div>
  </form>
}
